<template>
    <div>
        <button
            class="btn btn-md is-primary"
            @click="$modal.show('convert-address-to-hc')"
        >
            <slot>Konvertera till HC</slot>
        </button>

        <adaptive-form-modal
            name="convert-address-to-hc"
            title="Konvertera till HC"
            :action="route('api.addresses.convert-to-hc.store', address)"
            :callback="reloadPage"
        >
            <text-input
                label="Signeringsdatum"
                type="date"
                name="date"
                :value="date"
                :required="true"
            />
        </adaptive-form-modal>
    </div>
</template>

<script>
    import { format } from 'date-fns';

    export default {
        props: {
            address: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                date: null,
            };
        },
        mounted() {
            this.date = format(new Date(), 'YYYY-MM-DD');
        },
        methods: {
            reloadPage() {
                window.location = window.location.href;
            },
        },
    };
</script>
